import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Button, Container, Grid, Icon, Message } from 'semantic-ui-react'
import { BsBriefcase } from 'react-icons/bs'
import { useEditHandleError } from '../../Common/Hooks/useEditHandleError'
import {
  loadCompanyById,
  newCompany,
  saveCompany,
  updateState
} from '../Slice/CompanySlice'
import CompanyForm from '../Form/CompanyForm'
import './css/CompanyListPage.css'

export default function CompanyEditPage () {
  const { t } = useTranslation()
  const {
    isLoading,
    isSuccess,
    isError,
    message
  } = useSelector((state) => state.company)
  const dispatch = useDispatch()
  const { companyId } = useParams()
  const [errorList, goBack, handleError] = useEditHandleError('/company')

  useEffect(() => {
    if (companyId === 'new') {
      dispatch(newCompany())
    } else {
      dispatch(loadCompanyById(companyId))
    }
  }, [])

  useEffect(() => {
    handleError(isSuccess, isError, message)
    dispatch(updateState())
  }, [isSuccess, isError, message])

  const onSaveCompany = () => {
    dispatch(saveCompany())
  }

  return (
    <Container className='company-list-page'>
      <div className='company-title company-division'>
        <Grid columns={2}>
          <Grid.Column>
            <Icon size='large'><BsBriefcase /></Icon>
            {
              companyId === 'new'
                ? (<span>{ t('company.new') }</span>)
                : (<>
                  <span>{ t('company.edit') }</span>
                  <small className='mx-3'># { companyId }</small>
                </>)
            }
          </Grid.Column>
          <Grid.Column textAlign='right'>
            <Button
              icon
              labelPosition='left'
              color='grey'
              size='large'
              disabled={isLoading}
              onClick={goBack}>
              <Icon name='arrow circle left' /> { t('generic.goBack') }
            </Button>
            <Button
              icon
              labelPosition='left'
              color='green'
              size='large'
              disabled={isLoading}
              onClick={onSaveCompany}>
              <Icon name='save' /> { t('generic.save') }
            </Button>
          </Grid.Column>
        </Grid>
      </div>
      <div className='p-4'>
        <CompanyForm />
      </div>
      <div className='p-4'>
        { errorList.length > 0 &&
          <Message error icon='exclamation triangle'
                   header={ t('generic.validation.onSave') }
                   list={errorList} />
        }
      </div>
    </Container>
  )
}
